var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.17 14.894l-1.376 8.024L12 19.13l7.206 3.788-1.376-8.024 5.83-5.682-8.057-1.171L12 .74l-3.603 7.3L.341 9.21l5.83 5.683zm9.51-.698l.87 5.066L12 16.87l-4.55 2.392.87-5.066-3.682-3.588 5.087-.74L12 5.261l2.275 4.609 5.087.74-3.681 3.587z",
    fill: "#000"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9ImJhc2ljL3N0YXIiPgo8cGF0aCBpZD0iaWNvbiIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjE3MDM0IDE0Ljg5NDJMNC43OTQxMiAyMi45MTgyTDEyLjAwMDEgMTkuMTI5OEwxOS4yMDYxIDIyLjkxODJMMTcuODI5OSAxNC44OTQyTDIzLjY1OTYgOS4yMTE2MkwxNS42MDMxIDguMDQwOTRMMTIuMDAwMSAwLjc0MDQ3OUw4LjM5NzExIDguMDQwOTRMMC4zNDA1NzYgOS4yMTE2Mkw2LjE3MDM0IDE0Ljg5NDJaTTE1LjY4MDkgMTQuMTk2TDE2LjU0OTggMTkuMjYyMkwxMi4wMDAxIDE2Ljg3MDNMNy40NTAzOCAxOS4yNjIyTDguMzE5MyAxNC4xOTZMNC42Mzg1IDEwLjYwODFMOS43MjUyNCA5Ljg2ODk1TDEyLjAwMDEgNS4yNTk1OEwxNC4yNzUgOS44Njg5NUwxOS4zNjE3IDEwLjYwODFMMTUuNjgwOSAxNC4xOTZaIiBmaWxsPSJibGFjayIvPgo8L2c+Cjwvc3ZnPgo=";
export { SvgStar as ReactComponent };